import { Component, Input, OnInit } from '@angular/core';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';

/**
 * Dialog wrapper for the per-enrollment "View Payments Due" action.
 */
@Component({
  selector: 'app-view-payments-due-from-enrollment',
  templateUrl: './view-payments-due-from-enrollment.component.html',
  styleUrls: ['./view-payments-due-from-enrollment.component.css']
})
export class ViewPaymentsDueFromEnrollmentComponent extends BaseDialogComponent implements OnInit {
  @Input() override entityId;
}
